import React from "react";
import { toast } from "sonner";
import { FileText, Database, AlertTriangle } from "lucide-react";
import { api, formatApiError, formatDate } from "../../lib/apiClient";

const ICON = { formulario: FileText, secop: Database };

function SectionRow({ s, caseId, onChange, disabled }) {
  const toggle = async (e) => {
    try {
      const { data } = await api.post(`/reviewer/cases/${caseId}/kit-documental/anchoring/confirm`, { section: s.key, confirmed: e.target.checked });
      onChange(data);
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "No se pudo guardar la confirmación");
    }
  };
  return (
    <li className={`border p-3 ${s.anchored ? "border-gray-200" : s.confirmed ? "border-emerald-300 bg-emerald-50/40" : "border-amber-300 bg-amber-50/50"}`} data-testid={`anchoring-section-${s.key}`}>
      <p className="text-sm font-medium text-gray-900">{s.label}</p>
      {s.anchored ? (
        <ul className="mt-1 space-y-0.5">
          {s.sources.map((src) => {
            const Icon = ICON[src.tipo];
            return (
              <li key={src.tipo} className="text-xs text-gray-700 flex items-center gap-1.5" data-testid={`anchoring-source-${s.key}-${src.tipo}`}>
                <Icon className="w-3.5 h-3.5 text-primary" /> {src.detalle}
              </li>
            );
          })}
        </ul>
      ) : (
        <>
          <p className="mt-1 text-xs text-amber-800 flex items-center gap-1.5" data-testid={`anchoring-unanchored-${s.key}`}>
            <AlertTriangle className="w-3.5 h-3.5" /> Sin datos del formulario ni de SECOP: contenido generado por IA.
          </p>
          <label className="mt-2 flex items-start gap-2 text-xs text-gray-800 cursor-pointer">
            <input type="checkbox" checked={s.confirmed} onChange={toggle} disabled={disabled} className="mt-0.5 accent-primary" data-testid={`anchoring-confirm-${s.key}`} />
            <span>Revisé esta sección y confirmo que su contenido es adecuado para el caso.
              {s.confirmed && <span className="block text-gray-500">Confirmada por {s.confirmed_by} · {formatDate(s.confirmed_at)}</span>}
            </span>
          </label>
        </>
      )}
    </li>
  );
}

export function KitAnchoringPanel({ caseId, anchoring, onChange, disabled }) {
  if (!anchoring) return null;
  return (
    <section className="mb-6 border border-gray-200 bg-white p-6" data-testid="kit-anchoring-panel">
      <h2 className="font-serif text-xl text-gray-900 mb-1">Origen de cada sección</h2>
      <p className="text-xs text-gray-500 mb-4">
        Indica qué secciones se apoyan en el formulario del cliente y cuáles en SECOP. Las que no tienen ninguno requieren tu confirmación antes de aprobar.
      </p>
      <ul className="space-y-2">
        {anchoring.sections.map((s) => <SectionRow key={s.key} s={s} caseId={caseId} onChange={onChange} disabled={disabled} />)}
      </ul>
      {!anchoring.complete && (
        <p className="text-xs text-amber-700 mt-3" data-testid="anchoring-pending">Pendientes de confirmar: {anchoring.pending_confirmation.join(", ")}.</p>
      )}
    </section>
  );
}
